import { CharacterMode, CombustionProfileId, EngineProfileConfig, EngineProfileId } from '../types';
import { ENGINE_PROFILES } from '../config/engines';

export interface CharacterTuning {
  volumeMultiplier: number;
  filterCutoffMultiplier: number;
  intakeMultiplier: number;
  exhaustMultiplier: number;
  shiftPopProbability: number;
  limiterStyle: 'soft' | 'flutter' | 'aggressive';
}

export const CHARACTER_MODES: Record<CharacterMode, CharacterTuning> = {
  smooth: {
    volumeMultiplier: 0.85,
    filterCutoffMultiplier: 0.85,
    intakeMultiplier: 0.7,
    exhaustMultiplier: 0.7,
    shiftPopProbability: 0.0,
    limiterStyle: 'soft',
  },
  sport: {
    volumeMultiplier: 1.0,
    filterCutoffMultiplier: 1.0,
    intakeMultiplier: 1.0,
    exhaustMultiplier: 1.0,
    shiftPopProbability: 0.65,
    limiterStyle: 'flutter',
  },
  aggressive: {
    volumeMultiplier: 1.15,
    filterCutoffMultiplier: 1.25,
    intakeMultiplier: 1.35,
    exhaustMultiplier: 1.4,
    shiftPopProbability: 1.0,
    limiterStyle: 'aggressive',
  },
};

export function getEngineProfile(id: EngineProfileId): EngineProfileConfig {
  return ENGINE_PROFILES[id as CombustionProfileId] || ENGINE_PROFILES.v8;
}
